import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage/session";

import loginData from "./reducers/loginData";
import filtersReducer from "./reducers/filters";

const reducers = combineReducers({
  loginData: loginData,
  filters: filtersReducer,
}); // here goes all reducers

// Sessions used to live in localStorage, which survived a browser restart.
// Drop anything left there so an old session cannot outlive this change.
localStorage.removeItem("persist:root");

const persistConfig = {
  key: "root",
  storage, // sessionStorage: closing the browser ends the session
  whitelist: ["loginData", "filters"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);
